import axios from "axios"
import Consts from "../app/consts"

export default class AppService {
  static getBackendVersion() {
    // Making a request to see if the current version that the user has is the actual version on the s3 bucket
    return axios.get(Consts.BASE_API_URL + "/api/version")
  }
}
